import { Box, Flex, Image, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
const SkillsImage = ({ images, label }) => {
  const [img, setImg] = useState(images[1]);
  const [flag, setFlag] = useState(false);

  // useEffect(() => {
  //   AOS.init();
  // }, []);

  const changeImage = () => {
    setImg(images[0]);
    setFlag(true);
  };

  const defaultImage = () => {
    setImg(images[1]);
    setFlag(false);
  };

  return (
    <Box>
      <Box
        transform="rotate(45deg)"
        borderWidth={[4, 5, 7]}
        borderColor="teal"
        position="relative"
        p={{ lg: "20px", md: "20px", sm: "13px" }}
        m="13px"
        // bgGradient="linear(to-r, green.200, teal.300)"
      >
        <Text
          textAlign={"center"}
          // transform="rotate(-45deg)"
          // boxSizing="border-box"
          fontSize={{ lg: "15px", md: "13px", sm: "9px" }}
          transition="1s"
          position="absolute"
          top={0}
        >
          {label}
        </Text>
        <Image
          transform="rotate(-45deg)"
          onMouseOver={changeImage}
          onMouseLeave={defaultImage}
          w={{ lg: "80px", md: "60px", sm: "60px" }}
          src={img}
          alt={img}
          display="block"
          transition={"smooth"}
        />
      </Box>
    </Box>
  );
};

export default SkillsImage;
// transform="rotate(-45deg)"
// opacity={flag ? "100" : "0"}
